import { produce } from "immer";
import { Reducer } from "redux";
import {
  GET_X10_DEVICES,
  GET_X10_DEVICES_ERROR,
  GET_X10_DEVICES_SUCCESS,
  IX10DeviceQuery,
  IX10DevicesState,
  X10DevicesActionTypes
} from "./types";

export const DEFAULT_PAGE_SIZE = 50;

export const initialQuery: IX10DeviceQuery = {
  search: "",
  live: true,
  locationId: null,
  locationName: null,
  page: 0,
  size: DEFAULT_PAGE_SIZE,
  sort: "OUTLET"
};

export const initialState: IX10DevicesState = {
  query: initialQuery,
  result: null,
  loading: false,
  error: false
};

/** Any change other than the page itself starts again from the first page. */
export const mergeQuery = (
  current: IX10DeviceQuery,
  change: Partial<IX10DeviceQuery>
): IX10DeviceQuery => {
  const next = { ...current, ...change };
  const onlyPageChanged = Object.keys(change).every(key => key === "page");

  return onlyPageChanged ? next : { ...next, page: change.page ?? 0 };
};

const reducer: Reducer<IX10DevicesState, X10DevicesActionTypes> = (
  state = initialState,
  action: X10DevicesActionTypes
) =>
  produce(state, draft => {
    switch (action.type) {
      case GET_X10_DEVICES:
        draft.query = mergeQuery(state.query, action.payload);
        draft.loading = true;
        draft.error = false;
        break;
      case GET_X10_DEVICES_SUCCESS:
        draft.result = action.payload;
        draft.loading = false;
        break;
      case GET_X10_DEVICES_ERROR:
        draft.loading = false;
        draft.error = true;
        break;
      default:
        break;
    }
  });

export default reducer;
